import { ButtonHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  text: string;
  rounded?: string;
  buttonClass?: string;
}

export const Button = ({
  text,
  color = "bg-pisek-aqua",
  buttonClass = "",
  ...other
}: ButtonProps) => {
  return (
    <button
      className={twMerge(
        `w-fit text-sm font-semibold hover:brightness-90 focus:outline-none bg-slate-300 px-6 py-1 rounded-sm`,
        buttonClass
      )}
      {...other}
    >
      {text}
    </button>
  );
};
